<template>
  <main>
    <div class="main-container">
      <h3 class="custom-title text-center text-primary">Nouvelle commande</h3>
      <b-alert v-model="error" variant="danger" dismissible>{{ msg_alert }}</b-alert>

      <!-- Form Command -->
      <b-form @submit="onSubmit" id="form_command">
        <div>
          <p class="text-primary">Client</p>
          <vue-typeahead-bootstrap id="client"
                                   :data="options"
                                   v-model="clientSearch"
                                   :serializer="user => user.name"
                                   @hit="selectClient"
                                   @input="clearClient"
                                   placeholder="Nom du client"
          /> <!-- auto completion client -->
        </div>
        <p class="text-primary">Date</p>
        <b-form-input v-model="form.date" placeholder="Date" type="date"></b-form-input>
        <p class="text-primary">Commande</p>
        <b-form-textarea v-model="form.products" placeholder="Liste des produits commandés" rows="5"
                         max-rows="10"></b-form-textarea>

        <b-button variant="primary mt-4" type="submit">Go!</b-button>
      </b-form>

    </div>
  </main>
</template>

<script>

import {create_command, get_all_detail_users} from "@/services/ApiServices";

export default {
  name: "command-view",
  data: () => {
    return {
      form: {
        user_id: null,
        date: '',
        products: ''
      },
      clientSearch: '',
      error: false,
      msg_alert: '',
      options: []
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (!this.options.some(user => user.id === this.form.user_id && user.name === this.clientSearch)) {
        this.error = true;
        this.msg_alert = "Sélectionne un client dans les suggestions.";
        return;
      }
      create_command(this.form).then(response => {
        window.location.href = '/';
      }).catch(error => {
        this.error = true;
        this.msg_alert = error.message;
      })
    },
    selectClient(user) {
      this.clientSearch = user.name;
      this.form.user_id = user.id;
      this.error = false;
    },
    clearClient() {
      this.form.user_id = null;
    }
  },
  created() {
    get_all_detail_users().then(response => {
      this.options = response
    }).catch(error => {
      this.error = true;
      this.msg_alert = error.message;
    })
  }
}

</script>

<style scoped>

p {
  margin-bottom: 10px;
  margin-top: 10px;
}

#client {
  margin-top: 0px
}

button {
  min-width: 100px;
}

</style>
